var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMi3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 115,
    viewBox: "0 0 160 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.459 27.376C108.459 24.9507 109.833 17.9578 106.762 18.0002C102.224 18.0638 96.8416 21.4366 93.5776 24.5335C90.3136 27.6305 88.0947 32.4881 89.3616 36.8719C90.4568 40.683 93.9212 43.483 97.7077 44.777C101.494 46.0709 105.581 46.0921 109.604 45.9295C113.305 45.781 117.063 45.484 120.513 44.1477C123.963 42.8113 127.105 40.3083 128.386 36.879C130.405 31.4911 127.198 25.2406 122.359 22.0305C119.248 20.093 115.753 18.8346 112.109 18.3396",
    stroke: "#201B4C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6508 42L92.7219 76.5512C87.6182 79.9215 84.405 82.7716 81.7022 88.2297C79.727 92.3337 79.4597 97.0433 80.9582 101.341C82.4566 105.639 85.6004 109.18 89.7105 111.199C93.8206 113.218 98.5672 113.554 102.925 112.133C107.282 110.713 110.901 107.65 113 103.606",
    stroke: "#201B4C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111 108.423C113.996 110.233 117.471 111.125 120.983 110.986C124.496 110.846 127.886 109.681 130.725 107.639C133.564 105.597 135.722 102.77 136.927 99.5166C138.131 96.2633 138.327 92.7307 137.489 89.3676C135.828 82.6875 131.018 77.2541 124.115 76.227C123.971 64.8927 124.496 57.3696 124.352 46",
    stroke: "#201B4C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.231 31.3416C101.468 31.9971 100.599 33.0333 101.201 33.8369C101.697 34.5417 102.833 34.4149 103.489 34.9435C104.404 35.6484 104.023 37.0582 104.648 38.038C105.494 39.3138 107.53 39.0812 109.093 38.6935C111.023 38.2142 113.249 37.4811 113.829 35.7189C113.987 35.1174 114.036 34.4956 113.973 33.8792L113.897 32.1522C113.935 31.3753 113.745 30.6034 113.348 29.9177C113.135 29.5861 112.79 29.3445 112.387 29.2444C111.984 29.1444 111.555 29.1937 111.19 29.382C110.496 23.5949 103.84 30.0023 102.231 31.3416Z",
    fill: "#6753D7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4205 4.72138C27.4305 10.5608 20.5822 24.8732 23.7877 37.5182C26.9931 50.1632 41.242 58.0922 54.6805 57.9992C60.8563 57.9787 66.8721 56.0376 71.8909 52.446C75.907 49.4563 79.0329 45.433 80.934 40.8068C82.835 36.1806 83.4397 31.1256 82.6833 26.1828C81.0555 16.4146 73.7411 7.76992 64.2466 4.07733C59.4515 2.2917 54.3058 1.64403 49.2166 2.18556C44.1274 2.72708 39.2343 4.44295 34.9243 7.19742",
    stroke: "#201B4C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 33.3063C29.7422 34.4065 31.62 34.0973 32.4735 33.0834C33.3271 32.0695 33.4607 30.6673 33.6388 29.3945C33.8169 28.1217 34.1286 26.6836 35.19 25.871C36.0584 25.2023 37.2904 25.0657 38.1588 24.3538C38.5752 23.9338 38.8903 23.4297 39.0815 22.8776C39.2728 22.3256 39.3353 21.7393 39.2647 21.1611C39.2202 19.9961 38.9307 18.8456 38.9901 17.6879C39.0852 16.3447 39.6235 15.0666 40.5256 14.0424C41.4277 13.0183 42.6458 12.3022 44 12",
    stroke: "#6753D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47 16.088C48.0153 17.245 49.4208 17.9304 50.9107 17.995C52.4005 18.0596 53.8542 17.4981 54.9553 16.4328C55.5845 15.7739 56.0473 14.954 56.6621 14.2643C56.9439 13.9001 57.298 13.6062 57.6993 13.4035C58.1005 13.2009 58.5391 13.0945 58.9836 13.092C60.1624 13.1992 60.9724 14.3333 61.9343 15.0536C62.5178 15.4411 63.171 15.696 63.8524 15.8021C64.5337 15.9083 65.2285 15.8635 65.8927 15.6705C66.5568 15.4774 67.176 15.1404 67.7108 14.6807C68.2457 14.2211 68.6847 13.6487 69 13",
    stroke: "#6753D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9879 25C51.0591 25.8057 50.8135 26.6074 50.3033 27.2347C49.7932 27.8619 49.0587 28.2652 48.2561 28.3588C46.9347 28.4554 45.3907 27.742 44.4182 28.6412C43.5645 29.4363 43.906 30.8705 44.3217 31.9257C44.7374 32.9809 45.064 34.4076 44.2474 35.2176C43.0449 36.3694 40.8178 34.9947 39.4445 35.9607C39.1142 36.2532 38.8555 36.6177 38.6881 37.0261C38.5208 37.4345 38.4494 37.876 38.4794 38.3163C38.5461 39.1978 38.4402 40.0838 38.1677 40.9246C37.7742 41.7049 36.7349 42.3291 36 41.8089",
    stroke: "#6753D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45 47.2711C46.0654 48.5224 48.2606 48.0346 49.2903 46.7762C50.3199 45.5178 50.5845 43.814 50.9063 42.2092C51.228 40.6043 51.7357 38.9005 53.0514 37.9673C54.7317 36.7867 57.12 37.225 58.9433 36.2635C63.1049 34.0719 61.6462 26.5214 65.9722 24.648C67.3236 24.0683 68.8824 24.2662 70.3268 23.941C71.7712 23.6158 73.2942 22.421 72.951 21",
    stroke: "#6753D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9735 29C76.1035 30.2958 75.7523 31.5941 74.9862 32.6504C74.22 33.7067 73.0918 34.4481 71.8139 34.735C70.5828 34.9739 69.1623 34.8074 68.1715 35.6184C66.8967 36.719 67.3265 38.761 66.802 40.3541C66.3354 41.4687 65.6147 42.4602 64.6967 43.2505L63.3709 44.5974L59 49",
    stroke: "#6753D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83 34H88",
    stroke: "#201B4C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M105.465 105.495C105.527 105.518 105.579 105.557 105.612 105.606C105.645 105.655 105.659 105.711 105.651 105.766C105.642 105.822 105.613 105.874 105.566 105.915C105.52 105.956 105.459 105.984 105.391 105.995C105.324 106.006 105.254 105.999 105.192 105.976C105.129 105.953 105.077 105.915 105.043 105.866C105.009 105.818 104.995 105.762 105.002 105.707C105.009 105.651 105.038 105.599 105.083 105.558L105.853 105C105.905 105.044 105.946 105.096 105.971 105.154C105.996 105.212 106.005 105.273 105.998 105.334C105.99 105.395 105.966 105.454 105.928 105.506C105.89 105.559 105.837 105.604 105.775 105.638",
    stroke: "#201B4C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M106 101V102",
    stroke: "#201B4C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97 75C93.7825 75 90.8725 76.6404 88 79",
    stroke: "#201B4C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M128 57C129.21 58.5368 129.452 61.5609 128 67",
    stroke: "#6753D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24 11C26.308 7.70153 29.8464 5.22467 34 4",
    stroke: "#6753D7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMi3);
export default __webpack_public_path__ + "static/media/mi3.be815543f0e6d7d6999cc6534568fcd9.svg";
export { ForwardRef as ReactComponent };